var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.showOverlay,"opacity":0.6,"z-index":_vm.zIndex,"absolute":_vm.absolute}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }